<template lang="html">

    <div class="wrapper margin-menu -login column-center">
        <div class="contenedor-formulario-login">

            <h1 class="title-intro">Registro</h1>

            <form @submit.prevent="validate">

                <div class="contenedor-input">
                    <input type="text" class="input-text" v-validate="'required'" v-model="data.name" name="name"
                        :placeholder="$t('formulario.nombre')+'*'" />
                    <span :class="['error',{'animated shake' : view.clicked}]" v-if="view.clicked">{{
                        errors.first('name') }}</span>
                </div>

                <div class="contenedor-input">
                    <input type="text" class="input-text" v-validate="'required'" v-model="data.email" name="email"
                        :placeholder="$t('formulario.email')+'*'" />
                    <span :class="['error',{'animated shake' : view.clicked}]" v-if="view.clicked">{{
                        errors.first('email') }}</span>
                </div>

                <div class="contenedor-input">
                    <input type="password" class="input-text" v-validate="'required|min:8'" ref="password"
                        v-model="data.password" name="password" :placeholder="$t('formulario.password')+'*'" />
                    <span :class="['error',{'animated shake' : view.clicked}]" v-if="view.clicked">{{
                        errors.first('password') }}</span>
                </div>

                <div class="contenedor-input">
                    <input type="password" class="input-text" v-model="data.password_confirmation"
                        v-validate="'required|min:8|confirmed:password'" data-vv-as="password"
                        name="password_confirmation" :placeholder="$t('formulario.password_confirmation')+'*'" />
                    <span :class="['error',{'animated shake' : view.clicked}]" v-if="view.clicked">{{
                        errors.first('password_confirmation') }}</span>
                </div>




                <div class="contenedor-input -checkbox">
                    <input type="checkbox" class="input-check" v-validate="'required'" id="politica-contacto"
                        name="politica" :placeholder="$t('formulario.telefono')" />
                    <label for="politica-contacto">He leído y acepto la <router-link
                            :to="$t('enlaces.politica_privacidad')">
                            política de privacidad</router-link></label>
                    <span :class="['error',{'animated shake' : clicked}]" v-if="view.clicked">{{ errors.first('politica')
                        }}</span>
                </div>



                <button class="btn red with-border" :loading="loading">Registro</button>


            </form>
        </div>
    </div>

</template>

<script lang="js">

    import VeeValidate from 'vee-validate';
    import { mapActions } from 'vuex';

    export default {
        name: 'registro',
        data() {
            return {
                data: {
                    email: '',
                    password: '',
                    password_confirmation: '',
                    name: ''
                },
                view: {
                    clicked: false
                },
                loading : false,
                clicked : false
            }
        },
        methods: {
            ...mapActions(['requestRegister']),
            validate() {
                this.view.clicked = true;
                this.$validator.validateAll().then(canSend => {
                    if (canSend) {
                        this.requestRegister(this.data).then(r => {
                            if (r) {
                                alert("Usuario creado, revisa el email")
                            } else {
                                alert("Some error")
                            }
                        })
                    }
                });
            }
        }
    }

</script>


<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/views/registro.vue